const LoadingView = (props: { message?: string }) => {
  return (
    <div className="loadingScreen">
      <img src={'/loading.png'} />
      {props.message && <h2>{props.message}</h2>}
    </div>
  )
}
export default LoadingView
